// src/user/socialAuthMode.js
//
// 2026-05-24 (REVERT) — Google / Apple sign-in is back to POPUP-ONLY on
// every device. This is how the app worked in the last known-good build
// (LEX_saas_08032025 copy 3), where mobile login worked fine.
//
// Why the signInWithRedirect path was removed:
//   `signInWithRedirect` only works reliably when `authDomain` is on the
//   SAME origin as the app. Our authDomain is the Firebase default
//   `lextrack-ai.firebaseapp.com`, which is cross-origin to the app
//   domain `lextrackai.com`. On mobile Safari / iOS Chrome, cross-site
//   storage partitioning then wipes the SDK's pending-redirect state, so
//   when the page comes back from Google / Apple, `getRedirectResult()`
//   is empty and the user is NOT signed in ("missing initial state").
//
//   Pointing authDomain at `lextrackai.com` would fix redirect — but
//   ONLY if that domain also served Firebase's `/__/auth/handler`
//   endpoint. It does not (the app is a CRA SPA, not Firebase Hosting),
//   so that change broke login AND signup entirely.
//
//   `signInWithPopup` does NOT depend on the pending-redirect state and
//   works cross-origin on both desktop and mobile. So we use popup
//   everywhere, exactly like the last working build.
//
// These two helpers are kept because firebase.js and AuthContext.js
// still import them — but they now always steer callers to the popup
// path. The signInWithRedirect / getRedirectResult code in AuthContext
// stays in place but is effectively dormant (getRedirectResult just
// returns null on a normal page load).

export function isMobileAuthEnvironment() {
  // Always false → callers never take the signInWithRedirect branch.
  return false;
}

export function shouldFallbackToRedirect() {
  // Never fall back to signInWithRedirect. Surface real popup errors
  // (popup-blocked, etc.) to the user instead of bouncing them into the
  // broken cross-domain redirect flow.
  return false;
}
